import { useEffect, useRef } from "react";
import {
	buildCartReminderItems,
	notifyCartFinished,
	notifyCartItemAdded,
} from "../../services/cartReminder";

/**
 * Avisa a API de carrinho abandonado sempre que o carrinho do cardápio muda:
 * carrinho com itens reinicia o lembrete, carrinho esvaziado cancela.
 * Não envia nada na montagem (carrinho reidratado do localStorage não é item novo).
 */
export function useCartReminder(listBuying, businessDatas) {
	const isFirstRun = useRef(true);
	const previousLength = useRef(listBuying.length);
	const businessDatasRef = useRef(businessDatas);
	businessDatasRef.current = businessDatas;

	useEffect(() => {
		const wasEmpty = previousLength.current === 0;
		previousLength.current = listBuying.length;

		if (isFirstRun.current) {
			isFirstRun.current = false;
			return;
		}

		if (localStorage.getItem("@Inoveclube:type") === "table") return;

		const cdEmpresa = businessDatasRef.current.idBusiness;

		if (listBuying.length > 0) {
			notifyCartItemAdded({ cdEmpresa, itens: buildCartReminderItems(listBuying) });
		} else if (!wasEmpty) {
			notifyCartFinished({ cdEmpresa });
		}
	}, [listBuying]);
}
